module.exports = {
      id: "icon-audio-app-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-audio-app-store",
      toString: function () {
        return this.url;
      }
    }